import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes, c as clsx } from './p-50b8bf73.js';
import { n as nanoid } from './p-5959f2bd.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconWarningStyle0 = stylesCss;

const BiIconWarning = /*@__PURE__*/ proxyCustomElement(class BiIconWarning extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '441e4b406105c1135bc36b8d993e81ecf7c606c0', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: 'a4ee40280007380b768a8e263aa1c4d5d87a5efb', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 -960 960 960', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '6ef4f926377a52162d53a68a2c736f578cf494f1', d: 'M74.62-140 480-840l405.38 700zM178-200h604L480-720zm302-47.69q13.73 0 23.02-9.29t9.29-23.02-9.29-23.02-23.02-9.29-23.02 9.29-9.29 23.02 9.29 23.02 23.02 9.29m-30-104.62h60v-200h-60zM480-460' }))));
    }
    get el() { return this; }
    static get style() { return BiIconWarningStyle0; }
}, [1, "bi-icon-warning", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-warning"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-warning":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconWarning);
            }
            break;
    } });
}

export { BiIconWarning as B, defineCustomElement as d };
